import { DIMENSION_OPTIONS_MAP, DEFAULT_DIMENSION_MAP } from './constants';

import type { TDimension } from '../../types';
import type { IDimensionOption } from './types';

/**
 * 根据数据源获取维度选项
 */
export const getDimensionOptionsBySource = (source: IGenreSource): IDimensionOption[] => {
  return DIMENSION_OPTIONS_MAP[source];
};

/**
 * 根据数据源获取默认维度值
 */
export const getDefaultDimensionBySource = (source: IGenreSource): TDimension => {
  return DEFAULT_DIMENSION_MAP[source];
};
